import downloadFile from '@/helpers/download-file'

export default {
    namespaced: true,
    state: {
        data: [],
        organizerTemplateId: null,
    },
    mutations: {
        setData: (state, data) => {
            state.data = [];
            if(data) {
                state.data = [ ...data ]
            }
        },
        setOrganizerTemplateId: (state, data) => {
            state.organizerTemplateId = data
            state.data = []
        },
    },
    actions: {
        download: ({ state }, { doc, token, role = 'admin'}) => {
            const url = role != 'organizer' ?
                `/api/organizers/${state.organizerTemplateId}/documents/${doc.id}` :
                `/api/templates/${state.organizerTemplateId}/documents/${doc.id}`;
            downloadFile(url, token);
        },
        delete: ({ commit, state }, { doc, role = 'admin'}) => {
            const url = role != 'organizer' ?
                `/organizers/${state.organizerTemplateId}/documents/${doc.id}`:
                `/templates/${state.organizerTemplateId}/documents/${doc.id}`;

            return axios.delete(url)
                .then(resp => {
                    if (resp.data) {
                        commit("setData", resp.data.data ?? [])
                    }
                })
        },
        submit: ({ commit, state }, {files, role = 'admin'}) => {
            const data = new FormData
            files.forEach(file => {
                data.append('attachment[]', file)
            })
            const url = role != 'organizer' ? `/organizers/${state.organizerTemplateId}/documents` :
                `/templates/${state.organizerTemplateId}/documents`;
            return axios.post(url, data)
                .then( res => {
                    commit("setData", res.data.data ?? [])
                })
        }
    },
};
